// frontend/src/utils/normalizeTimeframe.ts

const CANONICAL = new Set([
  "1s", "5s", "15s", "30s",
  "1m", "2m", "3m", "5m", "10m", "15m", "30m",
  "1H", "2H", "3H", "4H", "6H", "8H", "12H", "16H", "23H",
  "D", "2D", "4D", "W", "M",
]);

const ALIAS_MAP: Record<string, string> = {
  d1: "D", D1: "D", "1d": "D", "1D": "D", day_1: "D",
  h1: "1H", H1: "1H", "1h": "1H", hour_1: "1H",
  h2: "2H", H2: "2H", "2h": "2H", hour_2: "2H",
  h4: "4H", H4: "4H", "4h": "4H", hour_4: "4H",
  m1: "1m", minute_1: "1m",
  m2: "2m", minute_2: "2m",
  m3: "3m", minute_3: "3m",
  m5: "5m", M5: "5m", minute_5: "5m",
  m10: "10m", minute_10: "10m",
  m15: "15m", M15: "15m", minute_15: "15m",
  m30: "30m", M30: "30m", minute_30: "30m",
  w1: "W", W1: "W", "1w": "W", "1W": "W", week_1: "W",
  M1: "M",
};

export function normalizeTimeframe(raw: string): string | null {
  if (CANONICAL.has(raw)) return raw;
  return ALIAS_MAP[raw] ?? null;
}
